import type { CompanyResponse, ProfileResponse } from "../common/types/companyTypes";

export type MockCustomerProfile = CompanyResponse & {
   freeDeliveryThreshold: number;
   deliveryFeeAmount: number;
};

type MockCustomerProfileData = Omit<MockCustomerProfile, "customerNumber">;

export const mockCustomerNumbers = ["999997", "999998", "999999"] as const;

export type MockCustomerNumber = (typeof mockCustomerNumbers)[number];

const profiles: Record<MockCustomerNumber, MockCustomerProfileData> = {
   "999997": {
      name: "Mock Skole SFO",
      email: "mock-skole@example.com",
      phone1: "99999997",
      phone2: "",
      businessChainLevel1: "GR00002519|NEDRE ROMERIKE INNKJ.SAMARB.",
      businessChainLevel2: "GR00002421|NITTEDAL KOMMUNE",
      businessChainLevel3: "",
      businessChainLevel4: "",
      customerGroup: "144|Skolefritidsordning",
      warehouse: "123|TINE Oslo",
      salesChannel: "511|Storhusholdning",
      billingAddress: ["Mock Skole", "1 Mock Allé", "9999 Mockheim"],
      shippingAddress: ["Mock Skole", "1 Mock Allé", "9999 Mockheim"],
      minimumOrderValue: 0,
      freeDeliveryThreshold: 0,
      deliveryFeeAmount: 0,
      activeCustomer: true
   },
   "999998": {
      name: "Mock Kafe",
      email: "mockkafe@example.net",
      phone1: "+47 99999998",
      phone2: "",
      businessChainLevel1: "GR00002651|KOMMUNER U/INNKJ@PSSAMARBEID",
      businessChainLevel2: "GR00003650|LILLESTRØM KOMMUNE",
      businessChainLevel3: "",
      businessChainLevel4: "",
      customerGroup: "107|Kafe",
      warehouse: "123|TINE Oslo",
      salesChannel: "511|Storhusholdning",
      billingAddress: ["Mock Kafe", "1 Mock Gate", "9999 Mockheim"],
      shippingAddress: ["Mock Kafe", "1 Mock Gate", "9999 Mockheim"],
      minimumOrderValue: 700,
      freeDeliveryThreshold: 0,
      deliveryFeeAmount: 0,
      activeCustomer: true
   },
   "999999": {
      name: "Mock AS",
      email: "customer@example.net",
      phone1: "+47 99999999",
      phone2: "",
      businessChainLevel1: "GR00000335|ENKELTSTÅENDE NORGE",
      businessChainLevel2: "GR00002999|ENKELTSTÅENDE STORHUSHOLDNING",
      businessChainLevel3: "",
      businessChainLevel4: "",
      customerGroup: "021|Kiosk /Convenience",
      warehouse: "169|TINE Frya",
      salesChannel: "511|Storhusholdning",
      billingAddress: ["Mock Company AS", "1 Mock Gate", "9999 Mockheim"],
      shippingAddress: ["Mock Company AS", "2 Mock Veg", "9999 Mockheim"],
      minimumOrderValue: 700,
      freeDeliveryThreshold: 1500,
      deliveryFeeAmount: 150,
      activeCustomer: true
   }
};

const userProfileAttributes = {
   id: "0123456789ABC",
   email: "customer@example.net",
   firstName: "Mock",
   lastName: "User",
   mobile: "+47 99999999",
   loginType: "AUTH",
   needsUpdate: false,
   additionalInfo: {}
} as const;

export const mockProfileResponse: ProfileResponse = {
   ...userProfileAttributes,
   companies: mockCustomerNumbers.map((customerNumber) => {
      const profile = profiles[customerNumber];
      const {
         name,
         email,
         phone1,
         phone2,
         businessChainLevel1,
         businessChainLevel2,
         businessChainLevel3,
         businessChainLevel4,
         customerGroup,
         warehouse,
         salesChannel,
         billingAddress,
         shippingAddress,
         minimumOrderValue,
         activeCustomer
      } = profile;
      return {
         customerNumber,
         name,
         email,
         phone1,
         phone2,
         businessChainLevel1,
         businessChainLevel2,
         businessChainLevel3,
         businessChainLevel4,
         customerGroup,
         warehouse,
         salesChannel,
         billingAddress,
         shippingAddress,
         minimumOrderValue,
         activeCustomer
      };
   })
};

export const getProfile = (mockCustomerNumber: MockCustomerNumber): MockCustomerProfile => ({
   ...profiles[mockCustomerNumber],
   customerNumber: mockCustomerNumber
});
